import React, { useContext, useEffect } from "react";
import { useRouter } from "next/router";
import { withRouter } from "../../utils/router-compat";
import { withFirebase } from "../Firebase";
import * as ROUTES from "../../constants/routes";
import AuthUserContext from "./authContext";
import Loading from "../UI/Loading";
import Navigation from "../UI/Navigation";
import { Context } from "../Cache";
import Button from "../UI/Button";

const withAuthorization = (Component, showNav) => {
  const WithAuthorization = (props) => {
    const authUser = useContext(AuthUserContext);
    const { state } = useContext(Context);
    const router = useRouter();
    const hasPendingSession =
      typeof window !== "undefined" &&
      (localStorage.getItem("token") || props.firebase?.auth?.currentUser);

    useEffect(() => {
      if (authUser === undefined) {
        return;
      }
      if (!authUser) {
        if (hasPendingSession) {
          return;
        }
        router.push(ROUTES.SIGN_IN);
        return;
      }
      if (!authUser.whitelisted) {
        router.push(ROUTES.NOT_WHITELISTED);
      }
    }, [authUser, hasPendingSession, router]);

    if (
      authUser === undefined ||
      (!authUser && hasPendingSession) ||
      !authUser ||
      !authUser.whitelisted ||
      !state.config
    ) {
      return <Loading />;
    }

    if (!authUser.admin) {
      return (
        <div className="min-h-screen bg-gray-100 flex items-center justify-center px-6">
          <div className="max-w-md w-full bg-white rounded-lg shadow-sm border border-gray-200 p-8 text-center">
            <h1 className="text-xl font-semibold text-gray-900">
              Web access is temporarily restricted
            </h1>
            <p className="mt-4 text-sm leading-6 text-gray-600">
              Web access is currently limited to admin users only. Please use
              the mobile app to view and manage incidents.
            </p>
            <div className="mt-6">
              <Button
                title={"Sign out"}
                onClick={async () => {
                  await props.firebase.doSignOut();
                  router.push(ROUTES.SIGN_IN);
                }}
              />
            </div>
          </div>
        </div>
      );
    }

    return (
      <>
        {showNav ? (
          <>
            <Navigation />
            <div className="h-12"></div>
          </>
        ) : null}
        <div className="h-screen flex overflow-hidden bg-gray-100">
          <div className="flex flex-col w-0 flex-1 overflow-hidden">
            <main
              className="flex-1 relative z-0 overflow-y-auto focus:outline-none"
              tabIndex="0"
            >
              <Component {...props} user={authUser} />
            </main>
          </div>
        </div>
      </>
    );
  };

  return withFirebase(withRouter(WithAuthorization));
};

export default withAuthorization;
